angular.module('powerOfAttorney')
    .component('powerOfAttorneyTable', {
        bindings: {
            projectId: '<',
            query: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/power-of-attorney/table.html',
        controller($scope, $state, Project, ProjectService, PowerOfAttorney, PowerOfAttorneyConst) {
            this.ProjectService = ProjectService;

            this.$onChanges = () => {
                PowerOfAttorney.table({project: this.projectId, search: this.query}).$promise.then(data => {
                    this.page = data;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                });
            }

            $scope.$on(PowerOfAttorneyConst.eventUpdate, () => this.$onChanges())
        }
    })
